export default {
  NONE: "none",
  IN_PROGRESS: "inProgress",
  DONE: "done",
};
